import React from 'react';

// Dedicated sort indicator (14px, design weight). Kept separate from IconChevronDown, which is a
// 20px chevron used for non-sort UI (map controls, accordions) and must not change.
const IconSorterDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M2.80005 4.90002L7.00005 9.10002L11.2 4.90002" stroke="#111111" strokeWidth="1.5" />
    </svg>
  );
};
export default IconSorterDown;
